import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden bg-navy-900" data-id="element-84">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-85" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-86">
        <FadeIn data-id="element-87">
          <div className="inline-block mb-4 px-3 py-1 border border-teal-500/30 bg-teal-500/10 text-teal-400 text-sm font-medium rounded-full tracking-wide" data-id="element-88">
            NUEVO PROTOCOLO DE RESCATE
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-89">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-90">
            Detén tu Migraña en{' '}
            <span className="text-teal-400" data-id="element-91">15 Minutos</span>
            <span className="block text-2xl md:text-3xl mt-4 text-slate-300 font-normal italic" data-id="element-92">
              (Sin Fármacos y Sin Encerrarte en la Oscuridad)
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-93">
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-94">
            El protocolo de rescate diseñado para profesionales que no pueden
            permitirse perder ni una hora de trabajo por culpa del dolor.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-95">
          <div className="relative mx-auto max-w-3xl rounded-2xl overflow-hidden shadow-2xl shadow-teal-900/20 border border-slate-800" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/jR8KGMcMY48YnErzQtEFFz/heylloyd-image-1775623115845.png" alt="Migraña Pro Protocolo en dispositivos" className="w-full h-auto object-cover" data-id="element-97" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-900/80 to-transparent pointer-events-none" data-id="element-98" />
          </div>
        </FadeIn>
      </div>
    </section>;
}